export const scrollTo = (block: Element | null | undefined) => {
  if (!block) {
    return;
  }

  try {
    // Плавно прокручивает к началу элемента, если это доступно в браузере
    block.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  } catch (error) {
    // Просто прокручивает к началу элемента, если браузер не умеет плавную прокрутку
    block.scrollIntoView();
  }
};
